"use strict";

/* A service / model */
_BannerFlowApp.factory("Feed", function ($resource, AuthInfo) {
    return $resource(
        "",
        {
            id: "@id"
        },
        {
            get: {
                method: "GET",
                url: "{0}/api/brands/{1}/feeds/:id".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                isArray: false
            },
            getSourceOptions: {
                method: "GET",
                url: "{0}/api/feeds/feedSourceOptions".format(BANNERFLOW_LEGACY_URL),
                isArray: true
            },
            leafs: {
                method: "POST",
                url: "{0}/api/brands/{1}/feeds/leafs".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformResponse: function (data, headers, statusCode) {
                    const response = {};
                    const dataObject = JSON.parse(data);

                    let errorMessage = "";
                    if (statusCode === 200) {
                        if (dataObject.error) {
                            if (
                                dataObject &&
                                dataObject.values &&
                                dataObject.values.length === 2 &&
                                dataObject.values[0] === "SizeError"
                            ) {
                                errorMessage = dataObject.values[1];
                            } else {
                                errorMessage =
                                    "Something went wrong when loading the dynamic data. Check your URL! ";
                            }
                        }
                    } else if (statusCode === 400) {
                        errorMessage = data;
                    } else {
                        errorMessage = "Something went wrong when loading the dynamic data.";
                    }

                    if (errorMessage) {
                        response.data = {
                            error: true,
                            errorMessage
                        };
                    } else {
                        var raw = $.parseJSON(dataObject.values[0]);

                        if (raw.Descendants.length === 1) {
                            raw = raw.Descendants[0];
                        }

                        var func = function (leaf) {
                            if (!leaf || !leaf.Descendants) return;

                            leaf.Descendants = _.sortBy(leaf.Descendants, function (d) {
                                return d.Descendants.length;
                            });

                            for (var i = 0; i < leaf.Descendants.length; i++) {
                                func(leaf.Descendants[i]);
                            }
                        };

                        func(raw);
                        response.data = raw;
                    }

                    response.headers = headers();

                    return response;
                }
            },
            preview: {
                method: "POST",
                url: "{0}/api/brands/{1}/feeds/preview".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                )
            },
            create: {
                method: "POST",
                url: "{0}/api/brands/{1}/feeds".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                )
            },
            update: {
                method: "PUT",
                url: "{0}/api/brands/{1}/feeds/:id".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                isArray: false
            },
            duplicate: {
                method: "POST",
                url: "{0}/api/brands/{1}/feeds/:id/duplicate".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                )
            },
            meta: {
                method: "POST",
                url: "{0}/api/brands/{1}/folders/feeds/search".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformResponse: function (data, headers) {
                    response = {};
                    response.data = JSON.parse(data);

                    response.headers = headers();
                    return response;
                }
            },
            metaBrandId: {
                method: "POST",
                url: "{0}/api/brands/:brandId/folders/feeds/search".format(BANNERFLOW_LEGACY_URL),
                transformResponse: function (data, headers) {
                    response = {};
                    response.data = JSON.parse(data);
                    response.headers = headers();
                    return response;
                }
            },
            state: {
                method: "PUT",
                url: "{0}/api/brands/{1}/folders/state".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformRequest: {
                    body: function (data, headers) {
                        var feeds = _.pluck(
                            _.filter(data.items, function (i) {
                                return !i.isFolder;
                            }),
                            "id"
                        );

                        var folders = _.pluck(
                            _.filter(data.items, function (i) {
                                return i.isFolder;
                            }),
                            "id"
                        );

                        data = JSON.stringify({
                            feeds: feeds,
                            folders: folders,
                            state: data.state
                        });

                        return data;
                    }
                }
            },
            lock: {
                method: "PUT",
                url: "{0}/api/brands/{1}/folders/lock".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformRequest: {
                    body: function (data, headers) {
                        var feeds = _.pluck(
                            _.filter(data.items, function (i) {
                                return !i.isFolder;
                            }),
                            "id"
                        );

                        data = JSON.stringify({
                            feeds: feeds,
                            lock: data.lock,
                            lockDependencies: data.lockDependencies
                        });

                        return data;
                    }
                }
            },
            drop: {
                method: "PUT",
                url: "{0}/api/brands/{1}/folders/move".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformRequest: {
                    body: function (data, headers) {
                        var feeds = _.pluck(
                            _.filter(data.items, function (i) {
                                return !i.isFolder;
                            }),
                            "id"
                        );

                        var folders = _.pluck(
                            _.filter(data.items, function (i) {
                                return i.isFolder;
                            }),
                            "id"
                        );

                        data = JSON.stringify({
                            feeds: feeds,
                            folders: folders,
                            folderToMoveTo: data.folder
                        });

                        return data;
                    }
                }
            }
        }
    );
});
